{
  "map-load-error": "При загрузке карты произошла ошибка",
  "map-try-again": "Повторить"
}
